export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',
        iconStyle: <i className="fas fa-home"/>,
        to: 'dashboard',
    },
    {
        title: 'Transfers',
        iconStyle: <i className="fas fa-shuttle-van"/>,
        to: 'transfers',
    },
]
